import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
